import { t } from "i18next";
import { Button, Icon } from "@livingmap/hippo";

import styles from "./Modal.module.scss";

interface Props {
  closeModal: () => void;
  onRevertChanges: () => void;
}

const RevertChanges: React.FC<Props> = ({ closeModal, onRevertChanges }) => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <h5 className={styles.title}>{t("modals.revert_changes.title")}</h5>
        <button className={styles.closeButton} onClick={closeModal}>
          <Icon dataQA="close-icon" name="close" size={18} />
        </button>
      </div>
      <div className={styles.contentContainer}>
        <p className={styles.description}>
          {t("modals.revert_changes.description")}
        </p>
        <div className={styles.buttonWrapper}>
          <Button
            dataQA="cancel-button"
            type="primary"
            size="regular"
            style="filled"
            text={t("btn_labels.cancel")}
            onClick={closeModal}
          />
          <Button
            dataQA="revert-changes-button"
            type="negative"
            size="regular"
            style="filled"
            text={t("modals.revert_changes.btn_labels.revert_changes")}
            onClick={onRevertChanges}
          />
        </div>
      </div>
    </div>
  );
};

export default RevertChanges;
